<template>
  <div>
    <h3 class="title-page">{{ $t("products") }}</h3>
    <div class="mdm-table">
      <div class="admin_container">
        <div class="text-right">
          <!--          Kelajakda ochiladi-->
          <!--          <v-btn-->
          <!--            class="mdm_modal_btn mr-4"-->
          <!--            color="primary"-->
          <!--            dark-->
          <!--            download-->
          <!--            :title="$t('add')"-->
          <!--            @click="$refs.productDialog.openDialog()"-->
          <!--          >-->
          <!--            <span>{{ $t("productsInDraft") }}</span>-->
          <!--          </v-btn>-->
          <!--          <v-btn-->
          <!--            class="mdm_modal_btn mr-4"-->
          <!--            color="primary"-->
          <!--            dark-->
          <!--            href="/files/example-product.xlsx"-->
          <!--            download-->
          <!--            :title="$t('exampleExcel')"-->
          <!--          >-->
          <!--            <v-icon class="mr-2" size="medium">mdi-file-download</v-icon>-->
          <!--            Excel-->
          <!--          </v-btn>-->
          <!--          <v-btn-->
          <!--            class="mdm_modal_btn mr-4"-->
          <!--            color="primary"-->
          <!--            dark-->
          <!--            @click="$refs.fileInput.click()"-->
          <!--          >-->
          <!--            <v-icon size="medium" class="mr-2">mdi-file-document-plus</v-icon>-->
          <!--            {{ $t("importFromExcel") }}-->
          <!--          </v-btn>-->
          <v-btn
            class="mdm_modal_btn"
            color="primary"
            dark
            @click="dialog = true"
            v-if="$can($permissions['PRODUCT_CREATE'])"
          >
            <!--          <span class="btn_span">+</span>-->
            <!-- <v-icon size="medium" class="mr-2">mdi-plus-circle</v-icon> -->
            {{ $t("create") }}
          </v-btn>
        </div>
        <div class="mobile_simple overflow-auto">
          <table-with-attribute
            fixed-header
            :headers="headers"
            :items="products"
            :page="productConfiguration.page"
          >
            <template #filter.name>
              <custom-input-text
                clearable
                @input="searchHandler"
                class="user_input no-margin"
                v-model="productConfiguration.name"
              ></custom-input-text>
            </template>
            <template #filter.attrs>
              <custom-input-text
                clearable
                @input="searchHandler"
                class="user_input no-margin"
                v-model="productConfiguration.attribute"
              ></custom-input-text>
            </template>
            <template #form.name="{ item }">
              <attribute-separation
                ref="attributeRef"
                :item="item"
                name-input
                @getProducts="getProducts"
              />
            </template>

            <template #form.actions="{ item, index }">
              <div class="d-flex">
                <v-btn
                  class="mr-2"
                  color="error"
                  small
                  @click="item._isEditing = false"
                >
                  {{ $t("toCancel") }}
                </v-btn>
                <v-btn small color="primary" @click="saveAttrs(item, index)">
                  {{ $t("save") }}
                </v-btn>
              </div>
            </template>
            <template #item.type_name="{ item }">
              <p>{{ item[`product_type_name_${$i18n.locale}`] }}</p>
            </template>
            <template
              #item.actions="{
                /**
                 * @type Object
                 * @property duplicate {string}
                 */
                item,
                index,
              }"
            >
              <v-tooltip
                v-if="item.duplicate"
                color="#fff"
                left
                nudge-right="10"
                nudge-top="35"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="$refs.duplicateProductDialog.openDialog(item.name)"
                  >
                    <vue-icon icon="newEyeIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("showDuplicates") }}</span>
              </v-tooltip>
              <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="item._isEditing = true"
                  >
                    <vue-icon icon="newFileEdit" />
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
              <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <!-- <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="btn_33 edit_btn"
                    @click="editItem(item, index)"
                  >
                    <vue-icon icon="editIcon" />
                  </v-btn> -->
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="editItem(item, index)"
                  >
                    <vue-icon icon="newPencilIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
              <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="deleteItem(item)"
                  >
                    <vue-icon icon="newTrashIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("delete") }}</span>
              </v-tooltip>
              <downloader
                :address="item['msdsFileName']"
                v-if="item['msdsFileName']"
              />
            </template>
            <span>{{ $t("downloadFile") }}</span>
            <template #item.attrs="{ item }">
              {{ item[`attrs_${$i18n.locale}`].join(" || ") }}
            </template>
            <template #item.name="{ item }">
              <p>{{ item[`name_${$i18n.locale}`] }}</p>
            </template>
            <template #item.remains="{ item }">
              {{ Number(item.remains) }}
              {{
                item.unitTypes ? item.unitTypes[0][`name_${$i18n.locale}`] : ""
              }}
            </template>
          </table-with-attribute>
          <VuePagination
            @update:limit="
              (limit) => {
                productConfiguration.limit = limit;
                productConfiguration.page = 1;
                changePage();
              }
            "
            v-model="productConfiguration.page"
            :length="lastPage"
            @input="changePage"
            max-page
            :limit="productConfiguration.limit"
          />
        </div>
      </div>

      <!--        modals-->
      <!--      <v-dialog v-model="dialog" max-width="950px">-->
      <!--        <validation-observer ref="form" v-slot="{ handleSubmit }">-->
      <!--          <v-form @submit.prevent="handleSubmit(save)">-->
      <!--            <v-card>-->
      <!--              <v-card-title-->
      <!--                class="d-flex justify-lg-space-between"-->
      <!--                style="border-bottom: 2px solid #dfe2e9"-->
      <!--              >-->
      <!--                <span class="headline" v-if="!editDialog"-->
      <!--                  >{{ $t("create") }}-->
      <!--                </span>-->
      <!--                <span class="headline" v-if="editDialog"-->
      <!--                  >{{ $t("editGroup") }}-->
      <!--                </span>-->
      <!--                <v-btn color="white" @click="dialog = false">-->
      <!--                  <v-icon color="lightGrey">mdi-close</v-icon>-->
      <!--                </v-btn>-->
      <!--              </v-card-title>-->

      <!--              <v-card-text>-->
      <!--                <v-row>-->
      <!--                  <v-col cols="12" md="6">-->
      <!--                    <v-row align="center">-->
      <!--                      <v-col cols="12" sm="4">-->
      <!--                        <div class="medium_15_01456A">-->
      <!--                          {{ $t("nameOfProduct") }}*-->
      <!--                        </div>-->
      <!--                      </v-col>-->
      <!--                      <v-col class="py-0" cols="12" sm="8">-->
      <!--                        <custom-input-text-->
      <!--                          v-model="editedItem.name"-->
      <!--                          :name="$t('name')"-->
      <!--                          :placeholder="$t('name')"-->
      <!--                          class="pt-0 user_input flex-grow-1 no-margin"-->
      <!--                          rules="required"-->
      <!--                        ></custom-input-text>-->
      <!--                      </v-col>-->
      <!--                      <v-col cols="12" sm="4">-->
      <!--                        <div class="medium_15_01456A">-->
      <!--                          {{ $t("groupOfProduct") }}*-->
      <!--                        </div>-->
      <!--                      </v-col>-->
      <!--                      <v-col class="py-2" cols="12" sm="8">-->
      <!--                        <vue-select-->
      <!--                          infinite-->
      <!--                          v-model="editedItem.product_group_id"-->
      <!--                          :get-item-promise="-->
      <!--                            ({ text, page }) =>-->
      <!--                              $store.dispatch('getProductGroups', {-->
      <!--                                name: text,-->
      <!--                                page,-->
      <!--                                limit: 15,-->
      <!--                              })-->
      <!--                          "-->
      <!--                          :items="productGroups"-->
      <!--                          :name="$t('group')"-->
      <!--                          :placeholder="$t('group')"-->
      <!--                          class="flex-grow-1"-->
      <!--                          rules="required"-->
      <!--                          @item-resolved="setProductGroup"-->
      <!--                          @next-page-resolved="-->
      <!--                            (data) =>-->
      <!--                              setProductGroup([...productGroups, ...data])-->
      <!--                          "-->
      <!--                        ></vue-select>-->
      <!--                      </v-col>-->
      <!--                      <v-col cols="12" sm="4">-->
      <!--                        <div class="medium_15_01456A">-->
      <!--                          {{ $t("typeProduct") }}*-->
      <!--                        </div>-->
      <!--                      </v-col>-->
      <!--                      <v-col class="py-2" cols="12" sm="8">-->
      <!--                        <vue-select-->
      <!--                          v-model="editedItem.product_type_id"-->
      <!--                          :get-item-promise="-->
      <!--                            ({ text, page }) =>-->
      <!--                              $store.dispatch('getProductTypes', {-->
      <!--                                name: text,-->
      <!--                                page,-->
      <!--                              })-->
      <!--                          "-->
      <!--                          :items="productTypes"-->
      <!--                          :name="$t('typeProduct')"-->
      <!--                          :placeholder="$t('typeProduct')"-->
      <!--                          class="flex-grow-1 user_input no-margin"-->
      <!--                          rules="required"-->
      <!--                          @item-resolved="setProductType"-->
      <!--                          @next-page-resolved="-->
      <!--                            (data) => setProductType([...productTypes, ...data])-->
      <!--                          "-->
      <!--                        ></vue-select>-->
      <!--                      </v-col>-->
      <!--                      <v-col cols="12" sm="4">-->
      <!--                        <div class="medium_15_01456A">-->
      <!--                          {{ $t("msdsFile") }}-->
      <!--                        </div>-->
      <!--                      </v-col>-->
      <!--                      <v-col class="py-0" cols="12" sm="8">-->
      <!--                        <validation-provider-->
      <!--                          v-if="!editedItem.fileUrl"-->
      <!--                          :name="$t('file')"-->
      <!--                          rules="document|not_empty_file"-->
      <!--                          v-slot="{ errors }"-->
      <!--                        >-->
      <!--                          <v-file-input-->
      <!--                            clearable-->
      <!--                            dense-->
      <!--                            v-model="editedItem.file"-->
      <!--                            :error-messages="errors[0]"-->
      <!--                          ></v-file-input>-->
      <!--                        </validation-provider>-->
      <!--                        <v-sheet-->
      <!--                          v-else-->
      <!--                          color="primary"-->
      <!--                          rounded-->
      <!--                          class="d-flex align-center"-->
      <!--                        >-->
      <!--                          <v-btn @click="deleteFile" icon color="white">-->
      <!--                            <v-icon>mdi-close</v-icon>-->
      <!--                          </v-btn>-->
      <!--                          <span-->
      <!--                            class="white&#45;&#45;text d-inline-block text-truncate"-->
      <!--                            style="max-width: 180px"-->
      <!--                            >{{ editedItem.msdsFileOriginalName }}</span-->
      <!--                          >-->
      <!--                          <v-spacer></v-spacer>-->
      <!--                          <downloader-->
      <!--                            btn-class="white"-->
      <!--                            :address="editedItem.fileUrl"-->
      <!--                          ></downloader>-->
      <!--                        </v-sheet>-->
      <!--                      </v-col>-->
      <!--                    </v-row>-->
      <!--                  </v-col>-->
      <!--                  <v-col cols="12" md="6">-->
      <!--                    <v-row align="center">-->
      <!--                      <v-col cols="12" sm="4">-->
      <!--                        <div class="medium_15_01456A">{{ $t("measure") }}*</div>-->
      <!--                      </v-col>-->
      <!--                      <v-col class="py-0" cols="12" sm="8">-->
      <!--                        <custom-select-->
      <!--                          v-model="editedItem.unitTypeIds"-->
      <!--                          :item-text="`name_${$i18n.locale}`"-->
      <!--                          :items="unitTypes"-->
      <!--                          :name="$t('measure')"-->
      <!--                          :placeholder="$t('measure')"-->
      <!--                          class="flex-grow-1 user_input no-margin"-->
      <!--                          multiple-->
      <!--                          rules="required"-->
      <!--                        ></custom-select>-->
      <!--                      </v-col>-->
      <!--                    </v-row>-->

      <!--                    <v-row align="center">-->
      <!--                      <v-col cols="12" sm="4">-->
      <!--                        <div class="medium_15_01456A">-->
      <!--                          {{ $t("expiration") }}-->
      <!--                        </div>-->
      <!--                      </v-col>-->
      <!--                      <v-col class="py-0" cols="12" sm="8">-->
      <!--                        <custom-input-text-->
      <!--                          v-model="editedItem.expiration"-->
      <!--                          :name="$t('expiration')"-->
      <!--                          class="flex-grow-1 user_input no-margin"-->
      <!--                          type="number"-->
      <!--                        ></custom-input-text>-->
      <!--                      </v-col>-->
      <!--                    </v-row>-->
      <!--                    <v-row align="center">-->
      <!--                      <v-col cols="12" sm="4">-->
      <!--                        <div class="medium_15_01456A">-->
      <!--                          {{ $t("limitProductCount") }}-->
      <!--                        </div>-->
      <!--                      </v-col>-->
      <!--                      <v-col class="py-0" cols="12" sm="8">-->
      <!--                        <custom-input-text-->
      <!--                          :min="0"-->
      <!--                          v-model="editedItem.limitCount"-->
      <!--                          :name="$t('limitProductCount')"-->
      <!--                          class="flex-grow-1 user_input no-margin"-->
      <!--                          type="number"-->
      <!--                        ></custom-input-text>-->
      <!--                      </v-col>-->
      <!--                      <v-col cols="12" sm="4">-->
      <!--                        <div class="medium_15_01456A">ТН ВЭД</div>-->
      <!--                      </v-col>-->
      <!--                      <v-col class="py-0" cols="12" sm="8">-->
      <!--                        <custom-input-text-->
      <!--                          class="pt-0 user_input flex-grow-1 no-margin"-->
      <!--                          v-model="editedItem.uniqueKey"-->
      <!--                        ></custom-input-text>-->
      <!--                      </v-col>-->
      <!--                    </v-row>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--                <v-row class="add_modal_row">-->
      <!--                  <v-col class="add_modal_row_child" cols="12" md="6">-->
      <!--                    <p class="medium_15_01456A text-uppercase">-->
      <!--                      {{ $t("allAttributes") }}:-->
      <!--                    </p>-->
      <!--                    <div class="search_div">-->
      <!--                      <custom-input-text-->
      <!--                        :loading="searchAttributeLoading"-->
      <!--                        :placeholder="$t('attributeSearch')"-->
      <!--                        class="for_icon_after"-->
      <!--                        @input="getAttributesByName"-->
      <!--                      >-->
      <!--                        <template #append>-->
      <!--                          <v-icon>mdi-search</v-icon>-->
      <!--                        </template>-->
      <!--                      </custom-input-text>-->
      <!--                      <div class="search_div_icon">-->
      <!--                        <img alt="" src="@/assets/img/search_icon.png" />-->
      <!--                      </div>-->
      <!--                    </div>-->

      <!--                    <div-->
      <!--                      v-for="attribute in filteredAttributes"-->
      <!--                      :key="`attr-${attribute.id}`"-->
      <!--                    >-->
      <!--                      <ProductAttribute-->
      <!--                        :attribute="attribute"-->
      <!--                        @addToProduct="(val) => addToProduct(attribute, val)"-->
      <!--                        @toggleShow="toggleShow(attribute)"-->
      <!--                      />-->
      <!--                    </div>-->
      <!--                  </v-col>-->
      <!--                  <ProductSelectedAttribute :item.sync="editedItem" />-->
      <!--                </v-row>-->
      <!--              </v-card-text>-->

      <!--              <v-card-actions class="footer_modal_user">-->
      <!--                <v-spacer></v-spacer>-->
      <!--                <v-btn-->
      <!--                  @click="dialog = false"-->
      <!--                  style="width: 50%"-->
      <!--                  color="#9EABBE"-->
      <!--                  dark-->
      <!--                >-->
      <!--                  {{ $t("toCancel") }}-->
      <!--                </v-btn>-->
      <!--                <v-btn color="primary" style="width: 50%" type="submit"-->
      <!--                  >{{ $t("save") }}-->
      <!--                </v-btn>-->
      <!--              </v-card-actions>-->
      <!--            </v-card>-->
      <!--          </v-form>-->
      <!--        </validation-observer>-->
      <!--      </v-dialog>-->

      <warning-dialog
        v-model="deleteModal"
        @apply="onDelete"
        @cancel="clearForm"
      ></warning-dialog>

      <input
        style="display: none"
        @change="uploadFileHandler"
        type="file"
        ref="fileInput"
      />
      <product-dialog ref="productDialog"></product-dialog>
      <DuplicateProductDialog
        ref="duplicateProductDialog"
      ></DuplicateProductDialog>
    </div>
  </div>
</template>

<script>
import WarningDialog from "@/components/ui/prompt/warning-dialog";
// import ProductSelectedAttribute from "@/components/reference/attribute/ProductSelectedAttribute";
// import ProductAttribute from "@/components/reference/attribute/ProductAttribute";
import {
  debounce,
  getValueByKey,
  makerPagination,
  trueSet,
} from "@/utils/pureFunctions";
import Downloader from "@/components/ui/downloader";
// import VueSelect from "@/components/ui/vue-select/VueSelect";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import AttributeSeparation from "@/components/attribute-separation/AttributeSeparation";
import TableWithAttribute from "@/components/ui/table-with-attribute/TableWithAttribute";
import ProductDialog from "@/components/reference/product/ProductDialog.vue";
import DuplicateProductDialog from "@/components/reference/product/DuplicateProductDialog.vue";
import i18n from "../../../plugins/I18n";

const DEFAULT_PRODUCT_FILTER = {
  name: null,
};

export default {
  components: {
    ProductDialog,
    TableWithAttribute,
    AttributeSeparation,
    VuePagination,
    // VueSelect,
    Downloader,
    WarningDialog,
    // ProductSelectedAttribute,
    // ProductAttribute,
    DuplicateProductDialog,
  },
  data() {
    return {
      searchAttributeLoading: false,
      searchFromAllAttribute: "",
      searchFromAllProductAttribute: "",
      attributes: [],
      dialog: false,
      deleteModal: false,
      productTypes: [],
      productGroups: [],
      unitTypes: [],
      products: [],
      search: "",
      editedIndex: null,
      productFilter: {
        ...DEFAULT_PRODUCT_FILTER,
      },
      editedItem: {
        name: null,
        product_group_id: null,
        product_type_id: null,
        attributes: [],
        unitTypeIds: [],
        limitCount: null,
        file: null,
        fileUrl: null,
        msdsFileOriginalName: null,
        id: null,
        uniqueKey: null,
      },
      productConfiguration: {
        limit: "50",
        page: 1,
        name: null,
        attribute: "",
      },
      lastPage: 0,
      fileDeleted: false,
    };
  },
  computed: {
    editDialog() {
      return this.editedItem.id !== null;
    },
    filteredAttributes() {
      if (this.editedItem.attributes) {
        const attributeIndex = this.editedItem.attributes.reduce(
          (obj, item) => {
            obj[item.id] = item.items;
            return obj;
          },
          {}
        );
        return this.attributes
          .filter((item) => {
            return (
              item.name && item.name.indexOf(this.searchFromAllAttribute) >= 0
            );
          })
          .map((item) => {
            item = Object.assign({}, item);
            const items = item.items.filter((attributeItem) => {
              return typeof attributeIndex[item.id] === "undefined"
                ? true
                : !attributeIndex[item.id].includes(attributeItem);
            });
            item.items = [...items];
            return item;
          });
      }

      return this.attributes;
    },
    isCreate() {
      return !this.editedIndex;
    },
    headers() {
      let items = [
        {
          text: "№",
          value: "index",
        },
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("count"),
          value: "remains",
        },
        //   Kelajakda ochiladi
        // {
        //   text: this.$t("group"),
        //   value: "group_name",
        // },
        {
          text: this.$t("category"),
          value: "type_name",
        },
        {
          text: this.$t("attributes"),
          value: "attrs",
        },
        {
          text: this.$t("limitProductCount"),
          value: "limitCount",
        },
        //   Kelajakda ochiladi
        // {
        //   text: this.$t("expiration"),
        //   value: "expiration",
        // },
      ];

      if (this.$can(this.$permissions.PRODUCT_UPDATE)) {
        items.push({ text: this.$t("action"), value: "actions" });
      }
      return items;
    },
  },
  watch: {
    dialog(dialog) {
      if (!dialog) {
        this.fileDeleted = false;
        this.editedIndex = null;
        const { form } = this.$refs;
        this.editedItem = {
          name: null,
          product_group_id: null,
          product_type_id: null,
          attributes: [],
          unitTypeIds: [],
          file: null,
          fileUrl: null,
          uniqueKey: null,
        };
        if (form) form.reset();
      }
    },
  },
  methods: {
    i18n() {
      return i18n;
    },
    setProductType(productTypes) {
      this.productTypes = productTypes;
    },
    setProductGroup(productGroups) {
      this.productGroups = productGroups;
    },
    saveAttrs(item) {
      const splitAttribute = {
        attributes: item._attrs,
        productId: item.id,
        productName: item.name.trim(),
      };
      this.$http
        .post("product/split-attribute", splitAttribute)
        .then(() => {
          this.getProducts();
        })
        .catch((err) => {
          this.setResponseError({ error: err });
        });
    },
    clickDown() {
      const { attributeRef } = this.$refs;
      if (attributeRef) {
        attributeRef.clickDown();
      }
    },
    searchHandler: debounce(async function () {
      this.productConfiguration.page = 1;
      await this.$router
        .replace({ query: { ...this.productConfiguration } })
        .catch(() => {});
      this.showLoading();
      await this.getProducts();
      this.clearLoading();
    }, 300),
    deleteFile() {
      this.editedItem.fileUrl = null;
      this.fileDeleted = true;
    },
    async uploadFileHandler({
      target: {
        files: [file],
      },
    }) {
      const { fileInput } = this.$refs;
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        this.showLoading();
        try {
          await this.$http.post("product/import-excel", formData);
          await this.getProducts();
          this.setSuccess({ text: this.$t("successfullySaved") });
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.clearLoading();
          fileInput.setAttribute("type", "text");
          fileInput.setAttribute("type", "file");
        }
      }
    },
    getAttributesByName: debounce(async function (name) {
      try {
        this.searchAttributeLoading = true;
        const { data } = await this.$store.dispatch("getAttributes", {
          name,
          show: true,
        });
        this.attributes = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.searchAttributeLoading = false;
      }
    }, 300),
    addToProduct(parent, item) {
      if (this.editedItem.attributes) {
        const productAttribute = this.editedItem.attributes.find(
          (filteredProduct) => {
            return parent.id === filteredProduct.id;
          }
        );
        if (productAttribute) {
          productAttribute.items.push(item);
        } else {
          this.editedItem.attributes.push({
            name: parent.name,
            id: parent.id,
            items: [item],
          });
        }
      } else {
        this.$set(this.editedItem, "attributes", [
          {
            name: parent.name,
            id: parent.id,
            items: [item],
          },
        ]);
      }
    },
    async editItem(item, index) {
      const {
        id,
        unitTypeIds,
        expiration,
        limitCount,
        msdsFileName,
        msdsFileOriginalName,
        uniqueKey,
      } = item;
      const formData = {};
      formData.id = id;
      this.showLoading();
      try {
        const {
          data: {
            data: { group_id, type_id, attributes, name },
          },
        } = await this.$http.get(`product/getBy-id?id=${id}`);
        if (group_id) {
          formData.product_group_id = group_id;
        }
        if (type_id) {
          formData.product_type_id = type_id;
        }
        formData.attributes = attributes;
        formData.name = name;
        formData.unitTypeIds = unitTypeIds;
        formData.expiration = expiration;
        formData.limitCount = limitCount;
        if (uniqueKey) {
          formData["uniqueKey"] = uniqueKey;
        }
        if (msdsFileName) {
          formData.fileUrl = msdsFileName;
        }
        formData.msdsFileOriginalName = msdsFileOriginalName;
        this.editedItem = formData;
        this.editedIndex = index;
        this.dialog = true;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    clearForm() {
      this.editedItem = {
        id: null,
        product_type_id: null,
        product_group_id: null,
        attributes: [],
      };
      const { form } = this.$refs;
      if (form) {
        form.reset();
      }
    },
    close() {
      this.dialog = false;
      this.clearForm();
    },
    closeDeleteModal() {
      this.deleteModal = false;
      this.clearForm();
    },
    deleteItem(item) {
      this.editedItem = { ...item };
      this.deleteModal = true;
    },
    async onDelete() {
      try {
        await this.$store.dispatch("deleteProduct", this.editedItem.id);
        if (this.products.length !== 1) {
          this.products = this.products.filter(
            (product) => product.id !== this.editedItem.id
          );
        } else {
          await this.getProducts();
        }
        this.closeDeleteModal();
      } catch (error) {
        this.setResponseError({ error });
      }
    },
    parseExpiration(expiration) {
      return parseInt(expiration) / (24 * 60 * 60);
    },
    setExpiration(expiration) {
      return parseInt(expiration) * 24 * 60 * 60;
    },
    async save() {
      this.showLoading();
      try {
        const {
          name,
          product_group_id,
          product_type_id,
          id,
          attributes,
          unitTypeIds,
          expiration,
          limitCount,
          file,
          uniqueKey,
        } = this.editedItem;
        const formData = new FormData();
        // let attributeIds = attributes.map((item) => item.id);
        // let attributeItems = attributes.map((item) => item.items);
        // console.log(attributeIds);
        // console.log(attributeItems);
        attributes.forEach((item, index) => {
          formData.append(`attributes[${index}].id`, item.id);
        });
        attributes.forEach((item, index) => {
          formData.append(`attributes[${index}].items`, item.items);
        });
        formData.append("name", name);
        formData.append("product_group_id", product_group_id);
        formData.append("product_type_id", product_type_id);
        unitTypeIds.forEach((unitType) => {
          formData.append("unitTypeIds", unitType);
        });
        if (file) {
          formData.append("file", file);
        }
        if (this.fileDeleted && !file) {
          formData.append("fileDeleted", this.fileDeleted);
        }
        if (expiration) {
          formData.append("expiration", this.setExpiration(expiration));
        }
        if (limitCount) {
          formData.append("limitCount", limitCount);
        }
        if (id) {
          formData.append("id", id);
        }
        if (uniqueKey) {
          formData.append("uniqueKey", uniqueKey);
        }
        await this.saveProduct(formData);
        // await this.attachAttribute({
        //   productId,
        //   attributes,
        // });
        await this.getProducts();
        await this.close();
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (error) {
        this.setResponseError({ error });
      } finally {
        this.clearLoading();
      }
    },
    async changePage() {
      await this.$router.replace({ query: { ...this.productConfiguration } });
      this.showLoading();
      await this.getProducts();
      this.clearLoading();
    },
    async saveProduct(formData) {
      try {
        const {
          data: { data },
        } = await this.$http.post("product/save", formData);
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async attachAttribute(formData) {
      try {
        await this.$http.post("product/saveAttributes", formData);
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getProducts() {
      const { limit, page, name, attribute } = this.productConfiguration;
      const { page: queryPage } = this.$route.query;
      const params = {
        limit,
        page: page - 1,
        name,
        attribute,
        sortBy: "name",
        sortDesc: true,
      };
      if (queryPage && +queryPage !== page) {
        await this.$router.push({ query: { page: page.toString() } });
      }
      try {
        const {
          data: { data, total },
        } = await this.$http.get("product/list", { params });
        this.products = data.map((item, index) => {
          item.duplicate = trueSet(item.duplicate);
          item._attrs = [];
          item._isEditing = false;
          item.index = 1 + (index + (page - 1) * limit);
          if (item.expiration) {
            item.expiration = this.parseExpiration(item.expiration);
          }
          if (item.unitTypes) {
            item.unitTypeIds = item.unitTypes.map((item) => {
              return `${item.id}`;
            });
          }
          return item;
        });
        this.lastPage = makerPagination({
          limit,
          total,
        }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    toggleShow(attribute) {
      const attr = this.attributes.find((item) => item.id === attribute.id);
      if (attr) attr.show = !attr.show;
    },
  },
  async created() {
    try {
      const { page } = this.$route.query;
      if (page) {
        this.productConfiguration.page = +page;
      }
      this.showLoading();
      // const { data: attributesData } = await this.$store.dispatch(
      //   "getAttributes"
      // );
      // const { data: productTypes } = await this.$store.dispatch(
      //   "getProductTypes",
      //   { limit: 10 }
      // );
      // this.unitTypes = await this.$store.dispatch("getUnitTypeList", {
      //   limit: 100,
      // });
      const options = getValueByKey(
        this.productConfiguration,
        this.$route.query
      );
      if (options.page && !isNaN(options.page)) options.page = +options.page;
      this.productConfiguration = options;

      await this.getProducts();
      // this.productTypes = productTypes;
      // this.attributes = attributesData;
    } catch (error) {
      this.setResponseError({ error });
    } finally {
      this.clearLoading();
    }
  },
};
</script>

<style scoped lang="scss">
div.v-card {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .v-card__text {
    padding-top: 16px;
  }
}
</style>
